import './styles/about.scss';

import { ImageBlock, PageTitle } from '../components/Primitives';

import { Breadcrumb } from '@progymedia/gatsby-theme-boutik-ecommerce/src/components/Primitives';
import Layout from '@progymedia/gatsby-theme-boutik-ecommerce/src/components/Layout/Layout';
import React from 'react';
import SEO from '@progymedia/gatsby-theme-boutik-ecommerce/src/components/Seo';
import { graphql } from 'gatsby';
import { usePageLocalization } from '@sbi-international/boutik.gatsby.plugin.multilocale';
import { useTranslation } from 'react-i18next';

export const query = graphql`
    query {
        about: allProductsJson(filter: { code: { eq: "englander_a-propos" } }) {
            nodes {
                code
                title {
                    en_CA
                    en_US
                    fr_CA
                }
                description {
                    en_CA
                    en_US
                    fr_CA
                }
                attributes {
                    content {
                        values {
                            en_CA
                            en_US
                            fr_CA
                        }
                        valuesMarkdownRemark {
                            en_CA
                            en_US
                            fr_CA
                        }
                    }
                    meta_title {
                        values {
                            en_CA
                            en_US
                            fr_CA
                        }
                    }
                    meta_description {
                        values {
                            en_CA
                            en_US
                            fr_CA
                        }
                    }
                }
            }
        }
        aboutBlocks: allProductsJson(
            filter: { code: { regex: "/^englander_a-propos-blocs/" } }
        ) {
            nodes {
                code
                title {
                    en_CA
                    en_US
                    fr_CA
                }
                description {
                    valuesMarkdownRemark {
                        en_CA
                        en_US
                        fr_CA
                    }
                }
                fields {
                    ...productsFieldsImagesFragment
                }
            }
        }
    }
`;

const About = ({ data }) => {
    const { currentLocale } = usePageLocalization();
    const { t } = useTranslation('pages');
    const metadataAttributes = data?.about?.nodes[0]?.attributes;
    const metadata = {
        title: metadataAttributes?.meta_title?.values[0][currentLocale],
        description:
            metadataAttributes?.meta_description?.values[0][currentLocale],
    };
    const pageTitle = data?.about?.nodes?.[0]?.title?.[currentLocale];
    const pageDesc = data?.about?.nodes?.[0]?.description?.[currentLocale];
    const aboutBlocks = data.aboutBlocks.nodes;

    return (
        <Layout>
            <SEO title={metadata?.title} description={metadata?.description} />
            <div className='about container'>
                <Breadcrumb
                    elements={[
                        { link: '/', name: t('layout:appliance.home') },
                        { link: '', name: pageTitle },
                    ]}
                />
                <PageTitle title={pageTitle} description={pageDesc} />
            </div>

            <div className='about-blocs'>
                {aboutBlocks?.map((bloc: any, index: number) => {
                    return (
                        <ImageBlock
                            key={`${bloc?.code}`}
                            title={bloc?.title?.[currentLocale]}
                            image={
                                bloc?.fields?.images?.[0]?.childImageSharp
                                    ?.gatsbyImageData
                            }
                        >
                            {index % 2 === 0 && (
                                <div className='about-bg'></div>
                            )}
                            <div
                                className='block-text'
                                dangerouslySetInnerHTML={{
                                    __html: bloc?.description
                                        ?.valuesMarkdownRemark?.[currentLocale],
                                }}
                            />
                        </ImageBlock>
                    );
                })}
            </div>
        </Layout>
    );
};

export default About;
